import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  useCurrentTrip,
  useLock,
  useResponsive,
  useBrowserSettings,
  useManageNavigation,
  useSetTrip,
} from "@/hooks";
import { Division } from "@/fetch/gworld";

const WORKING_HOLIDAY_ARRIVAL_ONLY_CODES = ["WH-AA", "WH-UU", "WH-CC"];

const useIntercomHandler = (input?: number | string) => {
  const [open, setOpen] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const { currentTrip } = useCurrentTrip();
  const { isProfileSetup, isAllowedToNavigate } = useManageNavigation();
  const { isLoading } = useSetTrip();
  const { isMobile } = useResponsive();
  const { isGapp } = useBrowserSettings();
  const { query } = useRouter();
  const [bootIntercom, setBootIntercome] = useState<boolean>(false);
  useEffect(() => {
    setTimeout(() => setBootIntercome(true), 30000);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!bootIntercom) return;
    //@ts-ignore
    if (!window.Intercom) return;

    if (
      currentTrip?.division !== Division.Superlite &&
      !Boolean(
        WORKING_HOLIDAY_ARRIVAL_ONLY_CODES.find(
          (each) => each === currentTrip?.trip_code
        )
      )
    )
      return;
    //@ts-ignore
    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: "v4kbpaee",
    });
  }, [bootIntercom, currentTrip]);

  const isNewPostDialogOpen = query?.dialog && query?.dialog === "new-post";
  const isPostDialogOpen = query?.dialog && query?.dialog === "post";

  const intercomEl = document.getElementsByClassName(
    "intercom-lightweight-app"
  )?.[0];

  const intercomActiveEl =
    document.getElementsByClassName("intercom-namespace")?.[0];
  const intercomScreenEl = document.getElementsByClassName(
    "intercom-lightweight-app-launcher"
  )?.[0];
  const intercomScreenActiveEl = document.querySelector(
    '[class^="intercom-with-namespace"]'
  );

  intercomEl?.setAttribute("style", "display:none");
  intercomActiveEl?.setAttribute("style", "display:none");

  if (
    (currentTrip?.division === Division.Superlite ||
      Boolean(
        WORKING_HOLIDAY_ARRIVAL_ONLY_CODES.find(
          (each) => each === currentTrip?.trip_code
        )
      )) &&
    isAllowedToNavigate &&
    isProfileSetup &&
    !isLoading &&
    !((isMobile || isGapp) && (isNewPostDialogOpen || isPostDialogOpen))
  ) {
    intercomEl?.setAttribute("style", "display:revert");
    intercomActiveEl?.setAttribute("style", "display:revert");
    if (isMobile) {
      intercomScreenEl?.setAttribute("style", "bottom:64px");
      intercomScreenActiveEl?.setAttribute("style", "bottom:64px");
    }
  }

  const checkForIntercom = () => {
    const intercomEl = document.getElementsByClassName(
      "intercom-lightweight-app"
    )?.[0];

    const intercomActiveEl =
      document.getElementsByClassName("intercom-namespace")?.[0];
    const intercomScreenEl = document.getElementsByClassName(
      "intercom-lightweight-app-launcher"
    )?.[0];
    const intercomScreenActiveEl = document.querySelector(
      '[class^="intercom-with-namespace"]'
    );
    console.log(intercomActiveEl);

    intercomEl?.setAttribute("style", "display:none");
    intercomActiveEl?.setAttribute("style", "display:none");

    if (
      (currentTrip?.division === Division.Superlite ||
        Boolean(
          WORKING_HOLIDAY_ARRIVAL_ONLY_CODES.find(
            (each) => each === currentTrip?.trip_code
          )
        )) &&
      isAllowedToNavigate &&
      isProfileSetup &&
      !isLoading &&
      isLoaded
    ) {
      intercomEl?.setAttribute("style", "display:revert");
      intercomActiveEl?.setAttribute("style", "display:revert");
      if (isMobile) {
        intercomScreenEl?.setAttribute("style", "bottom:64px");
        intercomScreenActiveEl?.setAttribute("style", "bottom:64px");
      }
    }
  };

  const checkFirst = () => {
    const intercomEl = document.getElementsByClassName(
      "intercom-lightweight-app"
    )?.[0];
    intercomEl?.setAttribute("style", "display:none");
  };

  //@ts-ignore
  if (typeof window !== "undefined" && window?.Intercom) {
    //@ts-ignore
    window?.Intercom("onHide", function () {
      setTimeout(() => setOpen(!open), 50);
    });
  }

  useEffect(() => {
    // checkFirst();
  }, []);

  useEffect(() => {
    // checkForIntercom();
  }, [
    currentTrip,
    isAllowedToNavigate,
    isProfileSetup,
    open,
    isMobile,
    isLoading,
    isLoaded,
  ]);

  const enableIntercom = () => {
    setIsLoaded(true);
  };

  return { checkForIntercom, enableIntercom };
};

export default useIntercomHandler;
